import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  linkedSignal,
  signal
} from '@angular/core';
import { Subscription } from "rxjs";
import { PreviewEvent, ViewSDKClient } from "../shared/services/view-sdk.service";

@Component({
  selector: 'app-pdf-viewer',
  imports: [],
  templateUrl: './pdf-viewer.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfViewer {
  private viewSDKClient = inject(ViewSDKClient);
  sdkReady = signal(false);
  pdfUrl = input.required<string>();
  pdfPreview = linkedSignal<{
    url: string,
    event?: PreviewEvent,
    complete: boolean,
    subscription: Subscription,
    error?: string
  } | null>(() => {
    if (!this.sdkReady()) {
      return null;
    }
    const url = this.pdfUrl();
    return ({
      url: this.pdfUrl(),
      complete: false,
      subscription: this.viewSDKClient.preview(url)
        .subscribe({
          next: event => this.pdfPreview.update(pdfPreview => ({...pdfPreview!, event}) ),
          error: msg => {
            console.error(msg);
            this.pdfPreview.update(pdfPreview => ({...pdfPreview!, event: undefined, error: msg}));
          },
          complete: () => {
            this.pdfPreview.update(pdfPreview => ({...pdfPreview!, event: undefined, complete: true}));
          }
        })
    });
  });

  constructor() {
    this.viewSDKClient.ready().then(() => this.sdkReady.set(true));
  }
}
